import React from 'react';
import { FormSpy } from 'react-final-form';

import createForm from '@swf/components/Forms/Form';

import Loader from '../../Loader/Loader';
import useCreateClubTable from '../hooks/useCreateClubTable';
import useGetClubTableStructures from '../hooks/useGetClubTableStructures';
import type { FormValues } from '../utils/common';

import styles from './Container.scss';
import CreateGameForm from './CreateGameForm';

const Form = createForm<FormValues>();

const Container = () => {
  const { response, loading } = useGetClubTableStructures();
  const {
    data: { tableParams }
  } = response;
  const gameData = tableParams ?? [];
  const {
    handleSubmit,
    loading: submitting,
    response: { error }
  } = useCreateClubTable(gameData);

  return (
    <Loader className={styles.loader} loading={loading}>
      <Form
        className={styles.formContainer}
        onSubmit={handleSubmit}
        initialValues={response.initialValues}
      >
        <FormSpy
          subscription={{
            values: true,
            submitSucceeded: true,
            submitError: true,
            submitFailed: true
          }}
          render={() => (
            <CreateGameForm gameData={gameData} loading={loading || submitting} error={error} />
          )}
        />
      </Form>
    </Loader>
  );
};

export default Container;
